import { ArrowUpLeft, Ghost, Instagram, MapPin, Music2, PhoneCall } from "lucide-react";
import { Link } from "react-router-dom";
import { brand, contact, text } from "../data/content";

export default function SiteFooter({ language }) {
  return (
    <footer className="site-footer">
      <div className="page-container footer-grid">
        <div className="footer-brand-block">
          <span className="footer-index">MOONLINE / PRINT</span>
          <h2>{text(language, brand.arLong, brand.enLong)}</h2>
          <p>{text(language, "نطبع فكرتك، ونغلف علامتك.", "We print your idea and wrap your brand.")}</p>
        </div>
        <div className="footer-nav-block">
          <span className="footer-label">{text(language, "استكشف", "Explore")}</span>
          <Link to="/services" data-testid="footer-services-link">{text(language, "الخدمات", "Services")}</Link>
          <Link to="/products" data-testid="footer-products-link">{text(language, "المنتجات", "Products")}</Link>
          <Link to="/contact" data-testid="footer-contact-link">{text(language, "تواصل معنا", "Contact")}</Link>
        </div>
        <div className="footer-contact-block">
          <span className="footer-label">{text(language, "بيانات التواصل", "Contact")}</span>
          <a href={contact.phoneHref} data-testid="footer-phone-link"><PhoneCall size={15} />{contact.phoneDisplay}</a>
          <a href={contact.mapsHref} target="_blank" rel="noopener noreferrer" data-testid="footer-map-link"><MapPin size={15} />{text(language, contact.addressAr, contact.addressEn)}</a>
          <a href={contact.instagramHref} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"><Instagram size={15} />{contact.instagramHandle}</a>
          <a href={contact.tiktokHref} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok-link"><Music2 size={15} />{contact.tiktokLabel}</a>
          <a href={contact.snapchatHref} target="_blank" rel="noopener noreferrer" data-testid="footer-snapchat-link"><Ghost size={15} />{contact.snapchatLabel}</a>
        </div>
      </div>
      <div className="page-container footer-bottom">
        <span>{text(language, "6661 Building · مشرفة · جدة", "6661 Building · Mishrifah · Jeddah")}</span>
        <span>{text(language, "حلول طباعة وتغليف للأعمال", "Print & packaging for business")}</span>
        <Link to="/contact" className="footer-arrow-link" data-testid="footer-quote-link">
          {text(language, "ابدأ محادثتك", "Start a conversation")} <ArrowUpLeft size={15} />
        </Link>
      </div>
    </footer>
  );
}
